"use client";

import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP, ScrollTrigger);
export default function Services() {
  const container = useRef<HTMLDivElement>(null);
  const domains = [{
    label: "Essential Wash",
    caption: "Premium exterior hand wash and tire shine for a pristine finish.",
    alt: "Luxury car exterior being hand washed with premium foam.",
    src: "https://inspired-chamois-1.cynergiasites.com/wp-content/uploads/2026/07/IMG_4875-1-scaled.jpeg?v=75i5h7t9m8i",
    srcset: "https://inspired-chamois-1.cynergiasites.com/wp-content/uploads/2026/07/IMG_4227.jpg?v=ynwleu7py4b-wvc-srcset",
    sizes: "https://inspired-chamois-1.cynergiasites.com/wp-content/uploads/2026/07/IMG_4227.jpg?v=w14sxlq4o9-wvc-sizes",
    link: {
      to: "/ServicesPage"
    }
  }, {
    label: "Interior Deep",
    caption: "Full steam cleaning, leather conditioning, and odor elimination.",
    alt: "Cleaned luxury car interior with leather seats and dashboard.",
    src: "https://inspired-chamois-1.cynergiasites.com/wp-content/uploads/2026/07/IMG_5244-1.jpeg?v=6e6b2l7vk3i",
    srcset: "https://inspired-chamois-1.cynergiasites.com/wp-content/uploads/2026/07/IMG_5244-1.jpeg?v=esy5fnpdyja-wvc-srcset",
    sizes: "https://inspired-chamois-1.cynergiasites.com/wp-content/uploads/2026/07/IMG_5244-1.jpeg?v=bu5vfe7688p-wvc-sizes",
    link: {
      to: "/ServicesPage"
    }
  }];
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".dd-eyebrow", {
        y: 24
      });
      gsap.set(".dd-heading", {
        y: 32
      });
      gsap.set(".dd-lead", {
        y: 24
      });
      gsap.set(".dd-card", {
        y: 40
      });
      gsap.to(".dd-eyebrow", {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 78%",
          once: true
        }
      });
      gsap.to(".dd-heading", {
        opacity: 1,
        y: 0,
        duration: 0.9,
        delay: 0.1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 78%",
          once: true
        }
      });
      gsap.to(".dd-lead", {
        opacity: 1,
        y: 0,
        duration: 0.8,
        delay: 0.25,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 78%",
          once: true
        }
      });
      gsap.to(".dd-card", {
        opacity: 1,
        y: 0,
        duration: 0.9,
        stagger: 0.18,
        delay: 0.35,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 78%",
          once: true
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".dd-eyebrow", ".dd-heading", ".dd-lead", ".dd-card"], {
        opacity: 1,
        y: 0
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return;
}